import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { Provider } from "./components/ui/provider";
import QueryProvider from "./providers/QueryProvider";

// After a redeploy the hashed lazy-chunk filenames change, so a tab still holding
// the previous index.html fails to fetch a chunk when navigating to a lazy route
// ("Failed to fetch dynamically imported module"). Reload once to pick up the new
// build; the 15s throttle avoids a reload loop if the server is genuinely down.
const handleChunkLoadError = () => {
  const last = Number(sessionStorage.getItem("nova_chunk_reload_at") || 0);
  if (Date.now() - last < 15000) return;
  sessionStorage.setItem("nova_chunk_reload_at", String(Date.now()));
  window.location.reload();
};
window.addEventListener("vite:preloadError", handleChunkLoadError);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider>
      <QueryProvider>
        <App />
      </QueryProvider>
    </Provider>
  </StrictMode>,
);
